import type { TipoDomandaDTO } from '@framework/api-client';
import { InquiryTypeTranslationSchema } from './InquiryTypeTranslationSchema';

/**
 * Transformer utilizzato nelle chiamate API per applicare le traduzioni a una
 * singola domanda.
 */
export function selectTranslatedInquiryType(data: TipoDomandaDTO) {
  return InquiryTypeTranslationSchema.translate(data, data.traduzioni ?? []);
}
